import {
  CalculationTimeFrameType,
  DateRange,
  KpiCalculationTimeFrameDto,
  Shift,
  ShiftQuickSelectSlots
} from '@hconnect/common/types'
import {
  QuickSelectSlotsToCalculationTimeFrameTypeMap,
  generateTimeRange
} from '@hconnect/common/utils'
import {useUpmPlantNow} from '@hconnect/upm'
import {Moment} from 'moment-timezone'

import {QuickSelectSlotsForSlotMap} from '../types'

import {useTimeRange} from './useTimeRange'

const getTimeFrameForDateRange = (
  selectedDateRange: DateRange,
  shifts: Shift[],
  plantNow: () => Moment
) => {
  const timeFrames: KpiCalculationTimeFrameDto[] = []
  const timeRange = generateTimeRange(selectedDateRange, shifts, plantNow)

  if (timeRange.startDate && timeRange.endDate) {
    timeFrames.push({
      calculationTimeFrameType: CalculationTimeFrameType.CustomDateRange,
      startDate: timeRange.startDate,
      endDate: timeRange.endDate
    })
  }

  return timeFrames
}

const getTimeFramesForSlot = (
  selectedSlot: ShiftQuickSelectSlots,
  shifts: Shift[],
  plantNow: () => Moment
) => {
  const timeFrames: KpiCalculationTimeFrameDto[] = []
  const slotsForSelectedSlot = QuickSelectSlotsForSlotMap[selectedSlot]

  slotsForSelectedSlot.forEach((quickSlot) => {
    const timeFrame = QuickSelectSlotsToCalculationTimeFrameTypeMap[quickSlot]
    try {
      const timeRange = generateTimeRange(quickSlot, shifts, plantNow)
      if (!timeFrame || !timeRange.startDate || !timeRange.endDate) return

      timeFrames.push({
        calculationTimeFrameType: timeFrame,
        startDate: timeRange.startDate,
        endDate: timeRange.endDate
      })
    } catch (e) {
      // If no available shifts for the selected slot, we skip adding this time frame
    }
  })

  return timeFrames
}

export const useTimeFrames = (shifts: Shift[]) => {
  const getPlantNow = useUpmPlantNow()
  const selectedDateRangeOrSlot = useTimeRange()
  const isDateRange = typeof selectedDateRangeOrSlot === 'object'

  const timeFrames: KpiCalculationTimeFrameDto[] = isDateRange
    ? getTimeFrameForDateRange(selectedDateRangeOrSlot, shifts, getPlantNow)
    : getTimeFramesForSlot(selectedDateRangeOrSlot as ShiftQuickSelectSlots, shifts, getPlantNow)

  return {
    timeFrames
  }
}
